<mat-card>
  <mat-card-header>
    <mat-card-title>Gestión de Conversión de Monedas</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>

    <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
    <mat-label *ngIf="!isSearching && msgError.length > 0">{{msgError}}</mat-label>

    <div *ngIf="!isSearching && item != null">

      <ng-container *ngIf="canEdit">

        <form [formGroup]="formGroup">

          <div fxLayout="row stretch" fxLayout.xs="column">

            <div fxFlex=50 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Fecha de Cotización</mat-label>
                <input matInput  [matDatepicker]="fechaCotizacionPicker"
                    (click)="fechaCotizacionPicker.open()" formControlName="FechaCotizacion">
                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaCotizacionPicker"></mat-datepicker-toggle>
                <mat-datepicker #fechaCotizacionPicker></mat-datepicker>
                <mat-error *ngIf="!formGroup.controls['FechaCotizacion'].valid && formGroup.controls['FechaCotizacion'].touched">
                  {{ getErrorFecha() }}
                </mat-error>
              </mat-form-field>
            </div>

          </div>

          <div fxLayout="row stretch" fxLayout.xs="column">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field style="width: 100%" appearance="outline">
                <mat-label *ngIf="!isMonedaSearching">Moneda Origen</mat-label>
                <mat-label *ngIf="isMonedaSearching">Cargando...</mat-label>
                <mat-select formControlName="MonedaOrigenId" [(value)]="monedaOrigenId">
                  <mat-option *ngFor="let moneda of monedas" [value]="moneda.Id">{{moneda.Codigo}}</mat-option>
                </mat-select>
                <mat-error *ngIf="!formGroup.controls['MonedaOrigenId'].valid && formGroup.controls['MonedaOrigenId'].touched">
                  {{ getErrorMonedaOrigen() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field style="width: 100%" appearance="outline">
                <mat-label *ngIf="!isMonedaSearching">Moneda Destino</mat-label>
                <mat-label *ngIf="isMonedaSearching">Cargando...</mat-label>
                <mat-select formControlName="MonedaDestinoId" [(value)]="monedaDestinoId">
                  <mat-option *ngFor="let moneda of monedas" [value]="moneda.Id">{{moneda.Codigo}}</mat-option>
                </mat-select>
                <mat-error *ngIf="!formGroup.controls['MonedaDestinoId'].valid && formGroup.controls['MonedaDestinoId'].touched">
                  {{ getErrorMonedaDestino() }}
                </mat-error>
              </mat-form-field>
            </div>

            <div fxFlex=50 fxFlex.xs=100 style="padding: 0px 10px 0px 10px">
              <mat-form-field style="width: 100%" appearance="outline">
                <mat-label>Precio Compra</mat-label>
                <input matInput formControlName="ValorCompra" type="number" step="any">
                <mat-error *ngIf="!formGroup.controls['ValorCompra'].valid && formGroup.controls['ValorCompra'].touched">
                  {{ getErrorValorCompra() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 style="padding: 0px 10px 0px 10px">
              <mat-form-field style="width: 100%" appearance="outline">
                <mat-label>Precio Venta</mat-label>
                <input matInput formControlName="ValorVenta" type="number" step="any">
                <mat-error *ngIf="!formGroup.controls['ValorVenta'].valid && formGroup.controls['ValorVenta'].touched">
                  {{ getErrorValorVenta() }}
                </mat-error>
              </mat-form-field>
            </div>

          </div>

        </form>

        <div fxLayout="row stretch" fxLayout.xs="column">
          <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
            <mat-checkbox [(ngModel)]="item.Activo" (keyup.enter)="onGuardar()" color="primary">Activo</mat-checkbox>
          </div>
        </div>

      </ng-container>

      <ng-container *ngIf="!canEdit">

        <div fxLayout="row stretch" class="zb-readonly">

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Fecha Cotización</b>: {{item.FechaCotizacion | date:'dd/MM/yyyy'}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Activo</b>: {{item.Activo ? 'Sí' : 'No'}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Moneda Origen</b>: {{item.MonedaOrigen}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Moneda Destino</b>: {{item.MonedaDestino}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Valor Compra</b>: {{item.ValorCompra | number: '1.2-2'}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Valor Venta</b>: {{item.ValorVenta | number: '1.2-2'}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

        </div>

      </ng-container>

    </div>

  </mat-card-content>

  <mat-card-actions style="margin-bottom: 20px;">
    <div fxLayout="row stretch" fxLayout.xs="column">
      <button mat-raised-button (click)="onGuardar()" *ngIf="canEdit" [disabled]="isProcessing()" color="primary" class="zb-button">{{isSaving ? 'Guardando...' : 'Guardar'}}</button>
      <button mat-raised-button (click)="onCancel()" color="warn" class="zb-button">{{canAdd || canEdit ? 'Cancelar' : 'Cerrar'}}</button>
      <button mat-raised-button (click)="onDelete()" *ngIf="canDelete && item != null && item.Id > 0" [disabled]="isSaving" color="warn" class="zb-button">
        {{ isDeleting ? 'Eliminando...' : 'Eliminar'  }}
      </button>
    </div>
  </mat-card-actions>

</mat-card>
